export const EQUIPMENT_SET_LENGTH = 5;
